import {useState, useMemo} from "react"
import {getCurrentSeason} from "utils/date_utils"

const startYear = 2005

export default function useSeasons() {

    const [currentSeason, setCurrentSeason] = useState(getCurrentSeason())
    const [season, setSeason] = useState(currentSeason)

    const seasons = useMemo(() => {    
        const seasons = {}

        for (let year = startYear; year <= currentSeason; year++) {
            seasons[year] = `${year - 1}/${year.toString().slice(2)}`
        }
        return seasons
    }, [currentSeason])


    return {seasons, currentSeason, season, setSeason}
}